import React from 'react';
import { Checkbox, Confirm, Icon } from 'semantic-ui-react';
import base, { firebase } from '../../../rebase';
import { FILETYPE_FINAL, FIREBASEREF_UPLOADS, FIREBASEREF_NEWUPLOADS } from '../../../globals';

class FileTableFinalCheckbox extends React.Component {
  state = { open: false, loadingFinal: false };

  handleFinalClick = () => this.setState({ open: true });
  handleCancel = () => this.setState({ open: false });

  handleConfirm = () => {
    this.setState({ open: false, loadingFinal: true });

    // First upload file, then metadata
    const newuploadref = firebase.database().ref(FIREBASEREF_UPLOADS).push();
    const key = newuploadref.key;
    base.update(FIREBASEREF_UPLOADS + "/" + key, {
      data: {
        type: FILETYPE_FINAL,
        originalKey: this.props.uploadId,
        status: "new",
        tour_operator: this.props.tour_operator,
        result_detailed: this.props.result_detailed
      },
      then: function (error) {
        base.update(FIREBASEREF_NEWUPLOADS, {
          data: { [key]: true }
        });
      }.bind(this)
    })
  }

  render() {
    if (!this.props.result_detailed) return null;

    if (this.props.status === "final") return <Icon name="checkmark" />;
    if (this.state.loadingFinal) return <Icon name="setting" loading />;

    const date = new Date(this.props.timestamp);
    const now = new Date();
    if (now - date > (2 * 1000 * 3600)) return null; // maximum 2 hours after upload

    return (
      <div>
        <Checkbox onClick={this.handleFinalClick} checked={false} />
        <Confirm
          open={this.state.open}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
          header={this.props.description}
          content="Are you sure you want to mark this request as final?" />
      </div>
    )
  }
}

export default FileTableFinalCheckbox;


// WEBPACK FOOTER //
// ./src/pages/Home/FileTable/FileTableFinalCheckbox.js